import { RegularButton, Modal } from 'fronton-react'
import { FC } from "react";
import './modalClasses.scss'

export interface SuccessSaveModalProps {
    open: boolean,
    text: string,
    onClose: () => void,
    onSave: () => void,
}

export const SuccessSaveModal: FC<SuccessSaveModalProps> = ({open, text, onClose, onSave}) => {
    return (
        <Modal
        size="s"
        show={open}
        className="add-calendar-modal"
        closeButton={false}
        onClose={onClose}
        overlayType="medium"
    >
        <div className="modal-content">
            <div className="modal-content-body">
                {text}
            </div>
            <div className="modal-content-actions">
                <RegularButton
                    key="submit"
                    size="s"
                    variant="primary"
                    className="modal-content-btn"
                    onClick={onSave}
                >
                    OK
                </RegularButton>
            </div>
        </div>
    </Modal>

    )
}
